/**
 * A type utility function to check if the provided object has the prop, and
 * provide a proper type to workaround Typescript's limitation
 *
 * @param obj - The object to check
 * @param prop - The prop to be used for the checking
 */
export const hasOwn = (obj, prop) => {
    if ('hasOwn' in Object) {
        return Object.hasOwn(obj, prop);
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment --- Support Chrome 87
    // @ts-expect-error
    // biome-ignore lint/suspicious/noPrototypeBuiltins: fallback for runtimes without `Object.hasOwn` (Chrome 87)
    return Object.prototype.hasOwnProperty.call(obj, prop);
};
//# sourceMappingURL=hasOwn.js.map